<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.deviceId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">设备名称 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属用户/ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入所属用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">日志类型 : </span>
              <div class="width300">
                <el-select class="width250" v-model="searchData.type" clearable>
                  <el-option :value="1" label="故障"></el-option>
                  <el-option :value="2" label="报警"></el-option>
                  <el-option :value="3" label="变位"></el-option>
                  <el-option :value="4" label="上下线"></el-option>
                  <el-option :value="5" label="操作"></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">绑定时间 : </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <div class="marginBottom10">
              <el-button
                size="medium"
                type="primary"
                @click="handleSearch"
                class="marginLeft10"
                >搜索</el-button
              >
            </div>
            <div class="marginBottom10">
              <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10 "
              >重置</el-button
            >
            </div>
          </div>
        </div>
      </template>
      <template slot="type" slot-scope="{ row }">
        <div>
          {{
            row.type == 1
              ? "故障"
              : row.type == 2
              ? "报警"
              : row.type == 3
              ? "变位"
              : row.type == 4
              ? "上下线"
              : row.type == 5
              ? "操作"
              : ""
          }}
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { logList } from "@/api/device/log";
import dayjs from "dayjs";

export default {
  name: "index",
  data() {
    return {
      searchData: {
        title: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
           {
            label: "设备ID",
            prop: "deviceId",
          },
          {
            label: "设备名称",
            prop: "name",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "操作人",
            prop: "operateNickname",
          },
          {
            label: "日志类型",
            prop: "type",
          },
          {
            label: "日志内容",
            prop: "content",
          },
          {
            label: "时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        // sort: " ",
        title: "",
        details: "",
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      logList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped>
</style>